import { useMemo } from 'react';
import { Route, RouteComponentProps, Redirect, Switch } from 'react-router-dom';

import { Sidebar } from 'pages/Sidebar';
import { NoChosenCompany } from 'pages/NoChosenCompany';
import { Artworks } from 'pages/Artworks';

import { Routes } from 'router/routes';

import styles from './styles.module.scss';

export const DashboardRouter: React.FC<RouteComponentProps> = () => {
  const memoizedChildren = useMemo(() => {
    return (
      <div className={styles.container}>
        <Route path={Routes.dashboard} component={Sidebar} />
        <Switch>
          <Route exact path={Routes.dashboard} component={NoChosenCompany} />
          <Route exact path={Routes.company('artworks')} component={Artworks} />
          <Route exact path={Routes.company('users')} component={() => <h1>Users</h1>} />
          <Route exact path={Routes.company('settings')} component={() => <h1>Settings</h1>} />
          <Route path="*">
            <Redirect to={Routes.dashboard} />
          </Route>
        </Switch>
      </div>
    );
  }, []);

  return memoizedChildren;
};
